var _defs, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBmDocuments = function SvgBmDocuments(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-90.5 -141.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.5 145.914)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M105.948,161.086h-14.9a.551.551,0,0,1-.552-.552V150.052a.551.551,0,0,1,.552-.552h4.966a.549.549,0,0,1,.39.162l2.045,2.045h7.5a.551.551,0,0,1,.552.552v8.276A.551.551,0,0,1,105.948,161.086Z",
    transform: "translate(-90.5 -149.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.5 143.707)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M105.4,148.259a.551.551,0,0,1-.552-.552v-1.1H91.052a.552.552,0,1,1,0-1.1H105.4a.551.551,0,0,1,.552.552v1.655A.551.551,0,0,1,105.4,148.259Z",
    transform: "translate(-90.5 -145.5)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(90.5 141.5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M105.4,142.6H91.052a.552.552,0,1,1,0-1.1H105.4a.552.552,0,0,1,0,1.1Z",
    transform: "translate(-90.5 -141.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBmDocuments, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/BM_Documents.2574f398.svg";
export { ForwardRef as ReactComponent };